import { useTranslationCapManage } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';
import { Button, Flex, Tabs, Text } from '@mantine/core';

import { CreatePersonLegal } from '@dealstack/frontend/app/pages/Project/Cap/CapEntityManageFlow/CapManageSidebar/CreatePersonTabs/CreatePersonLegal/CreatePersonLegal.tsx';
import { CreatePersonNatural } from '@dealstack/frontend/app/pages/Project/Cap/CapEntityManageFlow/CapManageSidebar/CreatePersonTabs/CreatePersonNatural/CreatePersonNatural.tsx';
import { Icon } from '@dealstack/frontend/shared/components/fundament/Icon';
import { PersonType } from '@dealstack/shared/lib/generated';
import { TEST_ELEMENT_IDS } from '@dealstack/shared/tests/testElementIds.ts';
import { PageContainer } from '@dealstack/frontend/shared/layout/PageContainer/PageContainer.tsx';

interface Props {
	onCreateSuccess: (createdEntityId: string, withClose?: boolean) => void;
	onCancel?: () => void;
	dealId: string;
	setCreateEntityMode: (value: PersonType) => void;
	setComputedName: (value: string) => void;
}

export const CreatePersonTabs = ({
	onCreateSuccess,
	onCancel,
	dealId,
	setCreateEntityMode,
	setComputedName,
}: Props) => {
	const tCapManage = useTranslationCapManage();

	const tabs = [
		{
			value: PersonType.LEGAL,
			icon: <Icon variant="building-office-company-entity-line" size="xl" />,
			testId: TEST_ELEMENT_IDS.CAP_DEAL_DIRECTORY_CREATE_LEGAL_PERSON,
			label: tCapManage('sidebar.create_entity_menu.organisation'),
		},
		{
			value: PersonType.NATURAL,
			icon: <Icon variant="user-profile" size="xl" />,
			testId: TEST_ELEMENT_IDS.CAP_DEAL_DIRECTORY_CREATE_NATURAL_PERSON,
			label: tCapManage('sidebar.create_entity_menu.natural_person'),
		},
	];

	return (
		<PageContainer align="center">
			<Flex direction="column" mt="1rem" gap="0.5rem">
				<Tabs radius="0" defaultValue={PersonType.LEGAL}>
					<Tabs.List mb="1rem">
						{tabs.map((tab) => (
							<Tabs.Tab
								key={tab.value}
								value={tab.value}
								leftSection={tab.icon}
								data-testid={tab.testId}
								onClick={() => setCreateEntityMode(tab.value)}
							>
								<Text fz="xl" fw={600}>
									{tab.label}
								</Text>
							</Tabs.Tab>
						))}
					</Tabs.List>

					<Tabs.Panel value={PersonType.LEGAL}>
						<CreatePersonLegal
							onCreateSuccess={onCreateSuccess}
							dealId={dealId}
							setComputedName={setComputedName}
						/>
					</Tabs.Panel>

					<Tabs.Panel value={PersonType.NATURAL}>
						<CreatePersonNatural
							onCreateSuccess={onCreateSuccess}
							dealId={dealId}
							setComputedName={setComputedName}
						/>
					</Tabs.Panel>
				</Tabs>

				<Button
					variant="subtle"
					color="gray"
					c="dark.8"
					size="md"
					fullWidth
					onClick={onCancel}
				>
					{tCapManage('sidebar.create_entity_box.cancel_button_text')}
				</Button>
			</Flex>
		</PageContainer>
	);
};
